import React, { useContext } from 'react'

import RegisterNewSubscription from './components/RegisterNewSubscription'
import UpdateActiveSubscription from './components/UpdateActiveSubscription'

import IpsaContext from '../../../../context/IpsaContext'
import AccountSidebar from '../../components/AccountSidebar'
import { Sidebar, MainContent } from '../../../../layouts/components/Structure'

const AccountSummary = () => {
    const {
        subscription: { status },
    } = useContext(IpsaContext)

    return (
        <>
            <Sidebar>
                <AccountSidebar />
            </Sidebar>
            <MainContent>
                {status &&
                (status.toLowerCase() === 'active' ||
                    status.toLowerCase() === 'trialing' ||
                    status.toLowerCase() === 'incomplete' ||
                    status.toLowerCase() === 'pastdue') ? (
                    <UpdateActiveSubscription />
                ) : (
                    <RegisterNewSubscription />
                )}
            </MainContent>
        </>
    )
}

export default AccountSummary
